import { Item, Stack } from './components';

export const ProductCardV2NutritionData = {
  Stack,
  Item,
};
